import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import {
  downloadPolicyPDFDocument,
  fetchTokenForBuyPolicy,
  getFullQuote,
  getFullQuoteRequestBody,
  getProposalDetails,
  getUserDetailsObject,
  paymentRedirection,
  saveISNPStatus,
  setPaymentInitiation,
} from 'src/services/buyPolicyService'
import LoadingModal from 'src/components/common/LoadingModal'
import { scrollToTop } from 'src/utils/commonMethods'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  showNotificationMessage,
  updateFullQuote,
  updateMemberDetails,
  updateNomineeDetails,
  updateOldPolicyId,
  updatePaymentLink,
  updatePolicyTenurePeriod,
  updateProposerDetails,
  updateSelectedFullQuote,
  updateSelectedQuote,
  updateUserDetails,
} from 'src/actions'
import { CONTACT, NOTIFICATION_TYPES } from 'src/utils/constants/common'
import ProposerDetailsReview from 'src/components/BuyPolicy/insuranceScreens/health/ProposerDetailsReview'
import { getISNPStatusRequestBody } from 'src/utils/commonMethods/buyPolicy'
import {
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  ERROR_ENCOUNTERED_ON_QOUTE,
  ERROR_OCCURED_ON_PROPOSAL,
  ERROR_ON_PAYMNET_INITITATION,
  INSURANCE_TYPE_CATOGORIES,
  QUOTE_404,
} from 'src/utils/constants/BuyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { ERROR_ON_PROPOSER_DETAILS } from 'src/utils/constants/Health'

const TermsAndConditions = () => {
  const classes = useStyles()
  const history = useHistory()
  const { search } = useLocation()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const [loading, setLoading] = useState(false)
  const [token, setToken] = useState(null)
  const [isFullQuoteFetchError, setIsFullQuoteFetchError] = useState(false)
  const [selectedFullQuote, setSelectedFullQuote] = useState(
    guestUserDetails?.selectedFullQuote
  )
  const [checkboxData, setCheckboxData] = useState({
    detailsProvided: false,
    appointTrovity: false,
    grantAuthorization: false,
    acceptReview: false,
    acceptPolicyDetails: !selectedFullQuote?.cisDocument,
  })
  const dispatch = useDispatch()
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  const enquiryId = searchParams.get('enquiryId')

  useEffect(() => {
    scrollToTop()
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const token = response?.res?.data?.access_token
      setToken(token)
      if (enquiryId) {
        fetchProposerDetails(token, enquiryId)
      } else {
        fetchFullQuoteDetails(token)
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchFullQuoteDetails = async (token, formBody = null) => {
    setLoading(true)
    const requestBody = formBody ?? getFullQuoteRequestBody(guestUserDetails)

    const fullQuoteResponse = await getFullQuote(token, requestBody)

    try {
      setLoading(false)
      if (fullQuoteResponse?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
        setIsFullQuoteFetchError(true)
      }
      // Success
      setLoading(false)
      const responseData = fullQuoteResponse?.res?.data
      const quoteDetailsList = responseData?.quoteDetails
      if (responseData?.success && quoteDetailsList?.length) {
        setSelectedFullQuote(quoteDetailsList?.[0])
        dispatch(updateSelectedFullQuote(quoteDetailsList?.[0]))
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
        setIsFullQuoteFetchError(true)
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ENCOUNTERED_ON_QOUTE,
        })
      )
      setIsFullQuoteFetchError(true)
    }
  }
  const fetchProposerDetails = async (token, enquiryId) => {
    const response = await getProposalDetails(token, enquiryId)

    try {
      if (response?.res?.status !== 200) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      const responseData = response?.res?.data
      if (responseData) {
        const {
          nomineeDetails,
          proposerDetails,
          memberDetails,
          selectedQuote,
          userDetails,
          oldPolicyId,
          policyTenurePeriod,
        } = getUserDetailsObject(responseData)

        dispatch(updateUserDetails(userDetails))
        dispatch(updateProposerDetails(proposerDetails))
        dispatch(updateMemberDetails(memberDetails))
        dispatch(updateNomineeDetails(nomineeDetails))
        dispatch(updateSelectedQuote(selectedQuote))
        dispatch(updatePolicyTenurePeriod(policyTenurePeriod))
        dispatch(updateOldPolicyId(oldPolicyId))

        const formBody = getFullQuoteRequestBody({
          nomineeDetails,
          proposerDetails,
          memberDetails,
          selectedQuote,
          userDetails,
          oldPolicyId,
          policyTenurePeriod,
        })

        await fetchFullQuoteDetails(token, formBody)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: ERROR_OCCURED_ON_PROPOSAL,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_PROPOSER_DETAILS,
        })
      )
    }
  }

  const saveMetadataAndNavigate = () => {
    setLoading(true)

    Promise.resolve(fetchTokenForBuyPolicy())
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      })
  }

  const saveISNPStatusTasks = async (token) => {
    setLoading(true)
    const formData = getISNPStatusRequestBody(
      guestUserDetails,
      INSURANCE_TYPE_CATOGORIES?.health,
      CURRENT_STATUS?.fullQuoteReceived
    )

    Promise.resolve(saveISNPStatus(token, formData))
      .then((response) => {
        // This is the response which is coming from backend.
        // The responseData is returned as a promise which is handled in following then block

        return response?.res?.data
      })
      .then(() => {
        // The responseData is returned here and main logic as per requirements will be handled here

        setLoading(false)
      })
      .catch(() => {
        // If there is any error from the backend it will be handled here

        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: ENCOUNTERED_ERROR_WHILE_SAVING,
          })
        )
      })
  }

  const handleBack = () => {
    dispatch(updateFullQuote(null))
    dispatch(updateSelectedFullQuote(null))
    history.push(
      '/individual/dashboard/buyPolicy/health/insuranceDetails/medical-condition'
    )
  }

  const handleBackToMemberDetails = () => {
    dispatch(updateFullQuote(null))
    dispatch(updateSelectedFullQuote(null))
    history.push(
      '/individual/dashboard/buyPolicy/health/insuranceDetails/member-details'
    )
  }

  const handlePay = async () => {
    setLoading(true)
    saveMetadataAndNavigate()
    try {
      const policyId = selectedFullQuote?.policyNumber

      if (policyId) {
        const paymentInitiationResponse = await setPaymentInitiation(
          token,
          policyId
        )

        try {
          if (paymentInitiationResponse?.res?.status !== 200) {
            setLoading(false)
            dispatch(
              showNotificationMessage({
                type: NOTIFICATION_TYPES?.ERROR,
                message:
                  NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
              })
            )
          }
          // Success
          setLoading(false)
          const responseData = paymentInitiationResponse?.res?.data
          if (responseData?.success) {
            navigateToPaymentPage()
          } else {
            dispatch(
              showNotificationMessage({
                type: NOTIFICATION_TYPES?.ERROR,
                message: responseData?.message,
              })
            )
          }
        } catch (err) {
          setLoading(false)
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message: ERROR_ON_PAYMNET_INITITATION,
            })
          )
        }
      } else {
        navigateToPaymentPage()
      }
    } catch (err) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: QUOTE_404,
        })
      )
    }
  }

  const navigateToPaymentPage = () => {
    setLoading(true)
    const fullQuote = selectedFullQuote
    let paymentLink = fullQuote?.paymentLink
    if (fullQuote?.paymentRequestParameterName) {
      paymentLink = `${fullQuote?.paymentLink}?${fullQuote?.paymentRequestParameterName}=${fullQuote?.paymentRequestParameterValue}`
    }
    dispatch(updatePaymentLink(paymentLink))
    paymentRedirection(paymentLink)
  }

  const handleChange = (event) => {
    setCheckboxData({
      ...checkboxData,
      [event?.target?.name]: event?.target?.checked,
    })
  }

  const isPayButtonEnabled = () => {
    let isEnabled = true
    Object.keys(checkboxData)?.forEach((key) => {
      if (!checkboxData?.[key]) {
        isEnabled = false
      }
    })

    return isEnabled
  }

  const handlePdfDownload = async (fileName, id, url, token) => {
    await downloadPolicyPDFDocument(fileName, id, url, token)
  }

  return (
    <>
      <LoadingModal loading={loading} />

      <div className={classes.mainContainer}>
        {isFullQuoteFetchError ? (
          <div className={classes.errorMessageContainer}>
            <div className={classes.errorContainer}>
              <div className={classes.errorTextContainer}>
                <span className={classes.errorText}>
                  Oops, seems something went wrong. Please go back, verify and
                  submit the details again.
                </span>
              </div>
              <div className={classes.errorTextContainer}>
                <span className={classes.errorText}>Or</span>
              </div>
              <div>
                <span className={classes.errorText}>
                  Please call us at <b>{CONTACT.Contact}</b> for further
                  assistance.
                </span>
              </div>
            </div>
            <div className={classes.errorBackContainer}>
              <Button
                type={'button'}
                onClick={handleBackToMemberDetails}
                className={classes.backButton}
              >
                Back
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <span className={classes.title}>
              Terms & Conditions or Declaration
            </span>
            <div className={classes.termsTitleContainer}>
              <div>
                <span className={classes.termsContent}>
                  Finalize your health insurance journey with a bang!
                </span>
                <span className={classes.termsContent}>
                  Take a moment to review the Proposal Form before sealing the
                  deal.
                </span>
                <span className={classes.termsContentDescription}>
                  <b>
                    It&apos;s the last dance move before your policy&apos;s
                    grand entrance!
                  </b>
                </span>
              </div>
            </div>
            <div>
              <div className={classes.conditions}>
                <div className={classes.conditions}>
                  <div>
                    <input
                      id='detailsProvided'
                      name='detailsProvided'
                      value={checkboxData.detailsProvided}
                      type='checkbox'
                      onChange={handleChange}
                      className={classes.checkboxControl}
                    />
                  </div>
                  <div className={classes.conditionsCheck}>
                    <div className={classes.conditions}>
                      <span className={classes.conditionsContentCheck}>
                        All details provided, including medical declarations,
                        are true and correct to my knowledge.
                      </span>
                    </div>
                    <div>
                      <span className={classes.conditionsContentDescription}>
                        I acknowledge and accept the Terms and Conditions.
                        Payment signifies my agreement and signature on the
                        proposal form.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.conditions}>
                <div className={classes.conditions}>
                  <div>
                    <input
                      id='appointTrovity'
                      name='appointTrovity'
                      value={checkboxData?.appointTrovity}
                      type='checkbox'
                      onChange={handleChange}
                      className={classes.checkboxControl}
                    />
                  </div>
                  <div className={classes.conditionsCheck}>
                    <div className={classes.conditions}>
                      <span className={classes.conditionsContentCheck}>
                        I appoint Trovity Insurance Broker Pvt. Ltd. as my
                        Insurance Broker.
                      </span>
                    </div>
                    <div>
                      <span className={classes.conditionsContentDescription}>
                        I understand that the KYC details will be verified as
                        per the mandatory IRDAI Master Guidelines, and the
                        details will be shared with the Insurer for policy
                        issuance.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.conditions}>
                <div>
                  <input
                    id='grantAuthorization'
                    name='grantAuthorization'
                    value={checkboxData?.grantAuthorization}
                    type='checkbox'
                    onChange={handleChange}
                    className={classes.checkboxControl}
                  />
                </div>
                <div className={classes.conditionsCheck}>
                  <span className={classes.conditionsContentCheck}>
                    I grant them authorization to represent me to Insurance
                    Companies/Agencies for my Insurance requirements.
                  </span>
                </div>
              </div>
              <div className={classes.conditions}>
                <div>
                  <input
                    id='acceptReview'
                    name='acceptReview'
                    value={checkboxData?.acceptReview}
                    type='checkbox'
                    onChange={handleChange}
                    className={classes.checkboxControl}
                  />
                </div>
                <div className={classes.conditionsCheck}>
                  <span className={classes.conditionsContentCheckForReview}>
                    I acknowledge and accept the Proposer details form.{' '}
                    <ProposerDetailsReview />
                  </span>
                </div>
              </div>
              {selectedFullQuote?.cisDocument ? (
                <div className={classes.conditions}>
                  <div>
                    <input
                      id='acceptPolicyDetails'
                      name='acceptPolicyDetails'
                      value={checkboxData?.acceptPolicyDetails}
                      type='checkbox'
                      onChange={handleChange}
                      className={classes.checkboxControl}
                    />
                  </div>
                  <div className={classes.conditionsCheck}>
                    <span className={classes.conditionsContentCheckForReview}>
                      I acknowledge and accept the Policy details.
                      <span
                        className={classes.termsPolicy}
                        onClick={() =>
                          handlePdfDownload(
                            selectedFullQuote?.cisDocument?.name,
                            selectedFullQuote?.cisDocument?.data.id,
                            selectedFullQuote?.cisDocument,
                            token
                          )
                        }
                      >
                        Policy Document
                      </span>
                    </span>
                  </div>
                </div>
              ) : null}
            </div>

            <div className={classes.buttonItems}>
              <div>
                <Button
                  type={'button'}
                  onClick={handleBack}
                  className={classes.backButton}
                  id='backButton'
                >
                  Back
                </Button>
              </div>
              <div>
                <Button
                  className={`${classes.payButton} ${
                    !isPayButtonEnabled() ? classes.disabledButton : ''
                  }`}
                  onClick={handlePay}
                  disabled={!isPayButtonEnabled()}
                  id='payButton'
                >
                  Ensure and Insure: Pay Now!
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default TermsAndConditions

const useStyles = makeStyles({
  termsAndConditions: {
    padding: '30px 80px 30px 80px',
    backgroundColor: 'white',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '19px',
    marginBottom: '20px',
    fontWeight: '600',
  },
  quoteListContainer: {
    display: 'flex',
    gap: '10px',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
  },
  termsContainer: {
    width: '66%',
  },
  termsTitle: {
    fontFamily: 'Roboto',
    fontSize: '19px',
  },
  termsTitleContainer: {
    border: '1px dashed',
    borderRadius: '10px',
    display: 'flex',
    padding: '20px',
    marginBottom: '30px',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    marginTop: '30px',
  },
  termsContent: {
    fontFamily: 'Roboto',
    fontStyle: 'italic',
    fontSize: '17px',
    display: 'flex',
    lineHeight: '1.5',
  },
  termsContentDescription: {
    color: '#619FAF',
    fontFamily: 'Roboto',
    fontStyle: 'italic',
    fontSize: '16px',
    lineHeight: '1.5',
  },
  termsReviewContent: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: '#2CA9CB !important',
    textDecoration: 'underline !important',
    textTransform: 'initial !important',
  },
  conditionsCheck: {
    marginLeft: '10px',
  },
  conditionsContentCheck: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  policyPeriod: {
    marginBottom: '30px',
  },
  policyPeriodTitle: {
    marginBottom: '20px',
  },
  policyPeriodTitleName: {
    fontFamily: 'Roboto',
    fontSize: '19px',
  },
  policyItems: {
    display: 'flex',
    border: '1px',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 150%)',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0px 4px 4px 0px #00000040',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '30px',
  },
  policyOtherItems: {
    display: 'flex',
    border: '1px',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 150%)',
    boxShadow: '0px 4px 4px 0px #00000040',
    padding: '30px 22px',
    borderRadius: '10px',
    marginLeft: '30px',
  },
  policyInput: {
    flex: '1',
  },
  policyOtherInput: {
    marginTop: '20px',
    flex: '1',
  },
  policyYear: {
    fontFamily: 'Roboto',
    fontSize: '17px',
  },
  policyYearRate: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    marginLeft: '40px',
  },
  policyPremium: {
    fontFamily: 'Roboto',
    fontSize: '17px',
  },
  policyOtherRates: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    marginLeft: '76px',
    color: '#A45E4C',
  },
  policySaveRate: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    marginLeft: '60px',
    color: '#2AB29B',
  },
  buttonItems: {
    display: 'flex',
    marginLeft: '10px',
    padding: '20px',
  },
  backButton: {
    color: '#2BA6C8 !important',
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    cursor: 'pointer !important',
    width: '120px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    background: '#E4EFF2 !important',
    textTransform: 'none !important',
    fontWeight: '600 !important',
  },
  payButton: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: 'white !important',
    background:
      'linear-gradient(228.98deg, #4EC4E4 9.13%, #0288AC 167.68%) !important',
    cursor: 'pointer !important',
    width: '265px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    marginLeft: '15px !important',
    textTransform: 'none !important',
    fontWeight: '600 !important',
  },
  digitContainer: {
    border: '1px',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 150%)',
    boxShadow: '0px 5px rgba(0,0,0,0.1)',
    padding: '30px 20px',
    borderRadius: '10px',
    marginLeft: '30px',
  },
  digitItems: {
    marginLeft: '11px',
    marginBottom: '20px',
  },
  digitImage: {
    width: '60px',
    marginBottom: '-5px',
  },
  digitContent: {
    marginBottom: '15px',
  },
  digitInput: {
    fontFamily: 'Roboto',
    fontSize: '10px',
  },
  digitBaseInput: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  digitOtherContent: {
    marginLeft: '60px',
    marginBottom: '25px',
  },
  digitOtherInput: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    display: 'flex',
    color: '#2BA6C8',
  },
  digitCoverRate: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    marginLeft: '9px',
  },
  digitInputRate: {
    marginBottom: '28px',
    marginLeft: '105px',
  },
  digitRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  totalPremium: {
    display: 'flex',
    border: '1px solid #EF669B',
    padding: '10px 10px',
    borderRadius: '10px',
    backgroundColor: 'white',
  },
  premiusubTitle: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  premiumRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    marginLeft: '142px',
  },
  popoverHeading: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    textTransform: 'uppercase',
    color: '#000000',
  },
  popoverContent: {
    textAlign: 'center',
    // opacity: '40%',
    boxShadow: '0px 0px 5px 0px #00000026',
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: '20px',
    gap: '10px',
  },
  nameDetails: {
    color: '#47BBDB',
    fontSize: '16px',
    fontFamily: 'Roboto',
  },
  otherDetails: {
    color: '#000000',
    fontSize: '13px',
    fontFamily: 'Roboto',
  },
  otherSubDetails: {
    color: '#959595',
    fontSize: '11px',
    fontFamily: 'Roboto',
  },
  errorMessageContainer: {
    padding: '40px',
  },
  errorContainer: {
    textAlign: 'center',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 100%)',
    border: 'none',
    padding: '50px 80px 50px 80px',
    boxShadow: '0px 6px 8px 0px #4DC3E333',
    borderRadius: '10px',
  },
  errorTextContainer: {
    paddingBottom: '10px',
  },
  errorText: {
    fontSize: '18px',
    textAlign: 'center',
  },
  errorBackContainer: {
    textAlign: 'center',
    padding: '10%',
  },
  disabledButton: {
    opacity: '0.5',
  },
  checkboxControl: {
    cursor: 'pointer',
    height: '15px',
    width: '15px',
  },
  conditionsContentDescription: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  conditions: {
    marginBottom: '15px',
    display: 'flex',
    // alignItems: 'center',
  },
  conditionsContentCheckForReview: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    display: 'flex',
    gap: '5px',
  },
  termsPolicy: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: '#2CA9CB !important',
    textDecoration: 'underline !important',
    textTransform: 'initial !important',
    cursor: 'pointer',
    fontStyle: 'italic',
  },
})
